module.exports = __webpack_public_path__ + "img/3.f9430bc1.jpg";